export default (input) => {
  return {
    ...input,
    children: input.children || input.label
  };
};
